// extracted by mini-css-extract-plugin
module.exports = {"staticSiteMarker":"static-preview_staticSiteMarker__3A6at"};